__turbopack_context__.v({
  "baseButton": "n68p_q_baseButton",
  "buttonsRow": "n68p_q_buttonsRow",
  "primaryButton": "n68p_q_primaryButton",
  "secondaryButton": "n68p_q_secondaryButton",
});
